import module from 'app/module.js'
import './style.scss'

class AppTableColumnsComponent {
  constructor ($element) {
    this.$element = $element
    this.columns = []
    this.appTable = null
    this.appTableColumns = null
  }

  add (element, component) {
    const columns = [...this.$element[0].querySelectorAll('app-table-column')]
    const index = columns.findIndex((item) => item === element[0])

    if (index >= 0) {
      this.columns.splice(index, 0, component)
      this.columns = [...this.columns]
    }

    this.setColumns()
  }

  remove (component) {
    const index = this.columns.indexOf(component)

    if (index >= 0) {
      this.columns.splice(index, 1)
      this.columns = [...this.columns]
    }

    this.setColumns()
  }

  list () {
    return this.columns
  }

  setColumns () {
    if (!this.appTable) return

    const gridTemplateColumns = this.columns.map((column) => column.width + (column.width === 'auto' ? '' : 'px'))

    this.appTable.$element.css('grid-template-columns', gridTemplateColumns.join(' '))
  }
}

module.directive('appTableColumns', () => {
  return {
    restrict: 'E',
    controller: AppTableColumnsComponent,
    require: {
      appTable: '^^appTable',
      appTableColumns: 'appTableColumns',
    },
    link (scope, element, attrs, ctrl, transclude) {
      ctrl.appTable['columns'] = ctrl.appTableColumns
      ctrl.appTableColumns['appTable'] = ctrl.appTable

      transclude((clone) => (element.append(clone)), element, 'columns')
    },
  }
})



// WEBPACK FOOTER //
// ./src/app/components/table/columns/component.js